import React, { useRef } from 'react';
import { Box, Button, Typography, List, ListItem, ListItemText } from '@mui/material';

interface FileUploadProps {
  files: File[];
  onChange: (files: File[]) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ files, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onChange(Array.from(e.target.files));
    }
  };

  return (
    <Box>
      <input
        type="file"
        multiple
        style={{ display: 'none' }}
        ref={inputRef}
        onChange={handleFileChange}
      />
      <Button
        variant="outlined"
        onClick={() => inputRef.current?.click()}
        sx={{ mb: 1 }}
      >
        Upload Attachments
      </Button>
      {files.length > 0 && (
        <List dense>
          {files.map((file, idx) => (
            <ListItem key={idx}>
              <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(1)} KB`} />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default FileUpload;
